import { Component, effect, inject, input } from '@angular/core';
import { NgClass, NgTemplateOutlet } from '@angular/common';

import { ContentSectionService } from './content-section.service';
import { ContentSectionTheme } from './content-section.model';

@Component({
  selector: 'wl-content-section',
  standalone: true,
  templateUrl: './content-section.component.html',
  styleUrls: [
    './content-section.component.ed.scss',
    './content-section.component.essent.scss',
  ],
  imports: [NgClass, NgTemplateOutlet],
  providers: [ContentSectionService],
})
export class ContentSectionComponent {
  readonly id = input<string>();
  readonly theme = input<ContentSectionTheme>(undefined);
  readonly fluid = input<boolean>(false);
  readonly hasContext = input<boolean>(false);

  readonly #contentSectionService = inject(ContentSectionService);

  constructor() {
    effect(() => this.#contentSectionService.theme.set(this.theme()), {
      allowSignalWrites: true,
    });
  }
}
